"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConfirmationSmsCodeFormController = require("./ConfirmationSmsCodeFormController");
Object.keys(_ConfirmationSmsCodeFormController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfirmationSmsCodeFormController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfirmationSmsCodeFormController[key];
    }
  });
});